import { range } from 'lodash/fp'

interface Args {
  currentPage: number
  totalPageCount: number
  omitSign?: string
  pageGroupLength?: number
}

const calcPaginationList = ({
  currentPage,
  totalPageCount,
  omitSign,
  pageGroupLength = 3,
}: Args) => {
  const trailLength = 2 // omitSign plus the first or last page number = 2
  const consecutiveGroupLength = pageGroupLength + trailLength
  const maxListLength = pageGroupLength + 2 * trailLength
  const lastLowestConsecutiveGroupItem = consecutiveGroupLength
  const firstHighestConsecutiveGroupItem =
    totalPageCount - consecutiveGroupLength

  if (totalPageCount <= maxListLength) {
    return range(1, totalPageCount + 1)
  }
  if (currentPage < lastLowestConsecutiveGroupItem) {
    return [...range(1, consecutiveGroupLength + 1), omitSign, totalPageCount]
  }
  if (currentPage > firstHighestConsecutiveGroupItem) {
    return [
      1,
      omitSign,
      ...range(firstHighestConsecutiveGroupItem, totalPageCount + 1),
    ]
  }
  const toTheSideAvg = (pageGroupLength - 1) / 2
  const toTheLeftSide = Math.floor(toTheSideAvg)
  const toTheRightSide = Math.ceil(toTheSideAvg)
  const pageGroup = range(
    Math.max(currentPage - toTheLeftSide, 1),
    Math.min(currentPage + toTheRightSide, totalPageCount) + 1
  )
  return [1, omitSign, ...pageGroup, omitSign, totalPageCount]
}

export const calcRenderablePaginationList = ({
  currentPage,
  omitSign = '…',
  ...rest
}: Args) =>
  calcPaginationList({ currentPage, omitSign, ...rest }).map((item, i) => ({
    isOmitSign: item === omitSign,
    isCurrentPage: item === currentPage,
    pageNr: Number(item),
    key: item === omitSign ? omitSign + i : item,
    omitSign,
  }))
